// The text of a template with its variables shown as samples: «‹name›» stands where a real value will be.

import { escHtml, markdownToHtml, sampleOf, templateToken } from '@confdeck/core-shared';

export interface TemplatePart { text: string; /** The name of the variable, when the piece is a sample. */
  var?: string }

/** Splits the text into plain pieces and variable samples. */
export function templateParts(text: string): TemplatePart[] {
  const out: TemplatePart[] = [];
  let last = 0;
  for (const m of text.matchAll(templateToken())) {
    const at = m.index ?? 0;
    if (at > last) out.push({ text: text.slice(last, at) });
    out.push({ text: sampleOf(m[1]!), var: m[1]! });
    last = at + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last) });
  return out;
}

/** The names of the variables of a template: from the field «variables» and from the text itself. */
export function templateNames(template: { variables?: unknown; subject?: unknown; body?: unknown }): string[] {
  const names: string[] = [];
  const add = (text: string) => { for (const m of text.matchAll(templateToken())) if (!names.includes(m[1]!)) names.push(m[1]!); };
  add(String(template.variables ?? ''));
  add(String(template.subject ?? ''));
  add(String(template.body ?? ''));
  return names;
}

/**
 * The letter's text as the reader sees it (decision 034: the template is markdown of the block editor), its variables as marked
 * samples. A variable is held by a mark the markdown never contains while the blocks are drawn, then becomes the sample.
 */
export function templateHtml(md: string, markClass: string): string {
  const vars: string[] = [];
  const held = md.replace(templateToken(), (_, name: string) => `\u0002${vars.push(name) - 1}\u0003`);
  return markdownToHtml(held, { record: () => null, file: () => null })
    .replace(/\u0002(\d+)\u0003/g, (_, i: string) => `<mark class="${markClass}">${escHtml(sampleOf(vars[Number(i)]!))}</mark>`);
}
